import { instance } from '@/services/avik-api-gateway'
import { VehicleWithdrawalReason } from '@/types/vehicle-withdrawal-reason'
import { AxiosResponse } from 'axios'

export function updateVehicleWithdrawalReason(
  body: Partial<VehicleWithdrawalReason>
): Promise<AxiosResponse<VehicleWithdrawalReason>> {
  return instance.put(`/vehicle-withdrawal-reason/${body.uuid}`, body)
}
